import React from 'react'
import { Container, Row, Col, Hidden } from 'react-awesome-styled-grid'

import CardIcon from '../components/CardIcon'
import CardModule from '../components/CardModule'
import { Section, SectionHeading, SectionContent } from '../components/Section'
import Title from '../components/Title'
import modules from '../mocks/modules'

const Modules = () => (
  <Section id="conheca" fluid>
    <SectionHeading
      className="texture-light"
      bg="primary"
      paddingTop={120}
      paddingBottom={60}
      fluid
    >
      <Container>
        <Row
          align="center"
          data-sal="slide-down"
          data-sal-delay="300"
          data-sal-easing="ease"
          data-sal-duration="1000"
        >
          <Col sm={4} className="t-center-mobile">
            <Title appearance="section" color="light" level={2}>
              Conheça os 3 módulos
            </Title>
          </Col>
          <Hidden xs>
            <Col sm={8}>
              <Row justify="center">
                <Col xs={10} sm={4}>
                  <CardIcon color="light" icon="blanche" title="13 técnicas" />
                </Col>
                <Col xs={10} sm={4}>
                  <CardIcon
                    color="light"
                    icon="notebook"
                    title="22 videoaulas"
                  />
                </Col>
                <Col xs={10} sm={4}>
                  <CardIcon color="light" icon="dish" title="9 pratos" />
                </Col>
              </Row>
            </Col>
          </Hidden>
        </Row>
      </Container>
    </SectionHeading>
    <SectionContent
      className="border-texture-top"
      paddingTop={60}
      paddingBottom={40}
    >
      <Container>
        <Row>
          {modules.map(({ label, body, action, totalPrice, price }, i) => (
            <Col xs={12} sm={6} lg={3} key={i}>
              <CardModule
                label={label}
                body={body}
                action={action}
                totalPrice={totalPrice}
                price={price}
                marginBottom={32}
                data-sal="slide-down"
                data-sal-delay={i * 100 + 400}
                data-sal-easing="ease"
                data-sal-duration="800"
              />
            </Col>
          ))}
        </Row>
      </Container>
    </SectionContent>
  </Section>
)

export default Modules
